import React, { Component } from 'react';
import {array, func, string} from 'prop-types';

import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';
import ModalPreviewer from '@components/ModalPreviewer/ModalPreviewer';

export default class HeaderShowcase extends Component {

  static propTypes = {
    component: func.isRequired,
    optionsGroup: array,
    backgrounds: array,
    codeTemplate: string,
    previewClassName: string,
    imagePath: string,
    modalPreviewClassName: string
  };

  render() {
    const {
      component,
      optionsGroup,
      backgrounds,
      codeTemplate,
      previewClassName,
      imagePath,
      modalPreviewClassName
    } = this.props;

    return (
      <ShowCase codeTemplate={codeTemplate}>
        <Preview className={previewClassName}>
          <ModalPreviewer
            previewText="Preview Header"
            imagePath={`headers/${imagePath}`}
            className={modalPreviewClassName}
          >
            {component}
          </ModalPreviewer>
        </Preview>
        <Controls optionsGroup={optionsGroup} backgrounds={backgrounds} />
      </ShowCase>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/components/Header/HeaderShowcase.js